import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import {
  map,
  Observable,
  startWith
} from 'rxjs';
import { FunctionsService } from 'src/app/services/api/functions.service';
import Swal from 'sweetalert2';
import { CreateOrderComponent } from 'src/features/service-order/create-order/ui/create-order/create-order.component';
import { buildCreateOrderDialogConfig } from 'src/features/service-order/create-order/ui/create-order/create-order-dialog.config';
import {
  applyCreatedOrdersToServices,
  applyOrderUpdateToServices,
  OrderService
} from 'src/entities/order';
import { isOrderEditable as isOrderEditableFn } from 'src/entities/order/model/order-status.model';
import { enrichServicesWithFileMeta } from 'src/entities/file/lib/merge-service-with-order';
import { computeMassOsServiceDate } from 'src/entities/file/lib/mass-os-services.utils';
import {
  ceilServiceAmount,
  canEditServiceAmount,
  hasServiceOrder,
  sameOrderNumberValue,
  showServiceDate,
  applyEditAmountResultToServices,
  applyItineraryCostDeltaDollars
} from 'src/entities/file';
import { getProgrammingLocacion } from 'src/entities/file/model/programming-service';
import {
  AVENTURA_OS_SERVICE_COLUMNS,
  SERVICE_TABLE_COLUMN_HEADERS
} from 'src/widgets/detail-file-service-table/service-table.config';
import { FileService } from '../../services/api/file.service';

@Component({
  selector: 'app-aventura-os',
  templateUrl: './aventura-os.component.html',
  styleUrls: ['./aventura-os.component.css']
})
export class AventuraOsComponent implements OnInit {
  @Input() isSSFF = false;

  readonly hasServiceOrder = hasServiceOrder;
  readonly isOrderEditable = isOrderEditableFn;
  readonly canEditAmount = canEditServiceAmount;
  readonly fileDisplayedColumns = [...AVENTURA_OS_SERVICE_COLUMNS];
  readonly headers = SERVICE_TABLE_COLUMN_HEADERS;
  readonly ceil = ceilServiceAmount;

  filteredOptions!: Observable<any[]>;
  fileControl = new FormControl<string | any>('');
  showServices = false;

  categoriaControl = new FormControl<string | null>('');
  servicioControl = new FormControl<string | null>('');
  estadoOsControl = new FormControl<string | null>('');
  numOsControl = new FormControl<string | null>('');
  proveedorControl = new FormControl<string | null>('');

  filteredCategorias!: Observable<any[]>;
  filteredServices!: Observable<any[]>;
  filteredEstadosOS!: Observable<any[]>;
  filteredNumOS!: Observable<any[]>;
  filteredProveedores!: Observable<any[]>;

  selectService: string | null = null;
  selectDate: string | null = null;
  selectOrderNumber: string | null = null;
  selectEstadoReserva: string | null = null;
  selectEstadoOS: string | null = null;
  selectProveedor: string | null = null;
  selectClient: string | null = null;
  selectNumberFile: string | null = null;

  filtersSecction: boolean = false;
  loader: boolean = false;
  selectedFile: string | null = null;
  personalCampoDataSource = new MatTableDataSource<any>();
  estadoBtnMasivo: any = 0;
  messageButtonOS: any = null;
  location: string = '';
  model: any;
  resultOS: any;

  startDate: Date | any;
  endDate: Date | any;
  filterValue: string = '';

  startDateSelected: Date | any;
  endDateSelected: Date | any;
  daySelected: string | null = null;
  selectFile: string | null = null;
  categoriaOfServiceSelected: string | null = null;

  arrayDays: any[] | null = null;
  arrayFiles: any[] = [];
  arrayTypesOfService: any[] | null = null;

  arrayServices: any[] | null = null;
  arrayDates: any[] | null = null;
  arrayClients: any[] | null = null;
  arrayOrderNumbers: any[] | null = null;
  arrayProveedores: any[] | null = null;
  arraySelectEstadoOS: any = [
    'CONFIRMADO',
    'EN PROCESO',
    'PAGADO',
    'CANCELADO',
    'ELIMINADO',
    'NOTACREDITO'
  ];

  usuario: string = '';
  categoriasFiltradas: any[] | null = null;

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.personalCampoDataSource.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.personalCampoDataSource.sort = value;
  }

  constructor(
    private readonly fileService: FileService,
    private readonly route: ActivatedRoute,
    private readonly functions: FunctionsService,
    private readonly toaster: ToastrService,
    public dialog: MatDialog,
    private readonly orderService: OrderService
  ) {}

  get isCreateOrderBusy(): boolean {
    return this.orderService.isCreateOrderBusy;
  }

  ngOnInit(): void {
    this.usuario = `${localStorage.getItem('nombre')} ${localStorage.getItem(
      'apellido'
    )}`;
    this.loader = true;

    this.functions.disparadorCambios.subscribe((tipo: string) => {
      if (tipo === 'create-order') {
        return;
      }
      this.onSelectionChanged({
        silent: tipo === 'reload-programming-silent'
      });
    });

    this.route.params.subscribe((params) => {
      this.location = params['location'];
      if (this.fileControl.value.id) {
        this.onSelectionChanged();
      }
    });

    this.getAllFiles();

    this.loader = true;
    this.showCustomStyleNotification();
    this.setupAutocompleteFilters();
  }

  private setupAutocompleteFilters(): void {
    this.filteredOptions = this.fileControl.valueChanges.pipe(
      startWith(this.fileControl.value ?? ''),
      map((value) => {
        const nombre =
          typeof value === 'string'
            ? value
            : `${value?.fileNumber}${value?.fileExtend || ''}`;
        return nombre
          ? this._filter(nombre as string)
          : this.arrayFiles.slice();
      })
    );

    this.filteredCategorias = this.categoriaControl.valueChanges.pipe(
      startWith(this.categoriaControl.value ?? ''),
      map((value) => this._filterArray(value, this.categoriasFiltradas))
    );

    this.filteredServices = this.servicioControl.valueChanges.pipe(
      startWith(this.servicioControl.value ?? ''),
      map((value) => this._filterArray(value, this.arrayServices))
    );

    this.filteredEstadosOS = this.estadoOsControl.valueChanges.pipe(
      startWith(this.estadoOsControl.value ?? ''),
      map((value) => this._filterArray(value, this.arraySelectEstadoOS))
    );

    this.filteredNumOS = this.numOsControl.valueChanges.pipe(
      startWith(this.numOsControl.value ?? ''),
      map((value) => this._filterArray(value, this.arrayOrderNumbers))
    );

    this.filteredProveedores = this.proveedorControl.valueChanges.pipe(
      startWith(this.proveedorControl.value ?? ''),
      map((value) => this._filterArray(value, this.arrayProveedores))
    );
  }

  private _normalizeFilterValue(value: string | null | undefined): string {
    return (value ?? '').toString().trim().toLowerCase();
  }

  private _filterArray(
    value: string | null,
    arrayToFilter: any[] | null
  ): any[] {
    const filterValue = this._normalizeFilterValue(value);
    return (arrayToFilter || []).filter((option) =>
      option?.toString().toLowerCase().includes(filterValue)
    );
  }

  onFilterInputChange(event: Event): void {
    const value = (event.target as HTMLInputElement | null)?.value;

    if (this._normalizeFilterValue(value)) {
      return;
    }

    this.applyFilterSelect();
  }

  getOptionText(option: any) {
    if (!option || !option.fileNumber) return '';

    const resultTexto = `${option.fileNumber}${
      option.fileExtend ? ' ' + option.fileExtend : ''
    }`;

    return resultTexto;
  }

  getAllFiles() {
    this.fileService.getAllFiles().subscribe((res: any) => {
      this.arrayFiles = res.getAllFiles;
      this.loader = false;
    });
  }

  getLocation() {
    if (this.location === 'cusco') {
      return 'Cusco';
    } else if (this.location === 'huaraz') {
      return 'Huaraz';
    }
    return '';
  }

  async openDialogEditTarifa(row: any): Promise<void> {
    if (!this.canEditAmount(row, this.isSSFF)) {
      Swal.fire({
        icon: 'warning',
        title: 'No se puede editar',
        text: 'No se puede editar el monto: ya tiene orden de servicio.',
        confirmButtonText: 'Entendido'
      });
      return;
    }

    this.functions
      .openDialogEditTarifa({
        serviceId: String(row.id),
        currentTotal: row.total,
        tipoServicio: row.tipoServicio,
        moneda: row.moneda,
        tipoCambio: row.tipoCambio,
        nombreServicio: row.nombreServicio
      })
      .afterClosed()
      .subscribe((result) => {
        if (!result?.success || !result.result) {
          return;
        }
        applyEditAmountResultToServices(this.model, result.result);
        applyItineraryCostDeltaDollars(
          this.fileControl.value,
          result.result.itineraryCostDeltaDollars
        );
        this.personalCampoDataSource.data = [...this.model];
      });
  }

  private _filter(nombre: string): any[] {
    const filterValue = nombre.toLowerCase();

    return this.arrayFiles.filter((fileOption: any) =>
      `${fileOption.fileNumber}${fileOption.fileExtend || ''}`
        .toLowerCase()
        .includes(filterValue)
    );
  }

  showCustomStyleNotification() {
    const message = 'Mismo File,<br/>Misma Moneda,<br/>Mismo Proveedor';
    this.toaster.info(message, 'Requisitos para generar OS masivas', {
      enableHtml: true
    });
  }

  applyFilter() {
    this.personalCampoDataSource.filter = this.filterValue.trim().toLowerCase();
  }

  showFiltersFx() {
    this.filtersSecction = !this.filtersSecction;
  }

  toggleAllRows() {
    const newCheckedState = !this.isAllSelected();

    this.personalCampoDataSource.filteredData.forEach((fila: any) => {
      if (this.isRowSelectable(fila)) {
        fila.checked = newCheckedState;
      }
    });
    this.estadoBtnMasivo = this.personalCampoDataSource.data.filter(
      (fila: any) => fila.checked && this.isRowSelectable(fila)
    ).length;
  }

  isRowSelectable(fila: any): boolean {
    return !hasServiceOrder(fila);
  }

  isAllSelected() {
    const selectableRows = this.personalCampoDataSource.filteredData.filter(
      (fila: any) => this.isRowSelectable(fila)
    );

    if (selectableRows.length === 0) {
      return false;
    }

    const selectedRows = selectableRows.filter((fila: any) => fila.checked);
    return selectedRows.length === selectableRows.length;
  }

  updateCheck(row: any) {
    row.checked = !row.checked;

    if (row.checked == true) {
      this.estadoBtnMasivo = Number(this.estadoBtnMasivo) + Number(1);
    } else {
      this.estadoBtnMasivo = Number(this.estadoBtnMasivo) - Number(1);
    }
  }

  openDialogReservaManual(
    tipo: string,
    nombreServicio: string,
    idItinerary: string,
    idRegistro: string,
    nombreProveedor: string,
    editcode: boolean,
    service?: any
  ): void {
    const dialogRef = this.functions.openDialogReservaManual(
      tipo,
      nombreServicio,
      idItinerary,
      idRegistro,
      nombreProveedor,
      'transportes',
      editcode,
      service?.order?.orderId,
      service
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.shouldRefresh) {
        this.onSelectionChanged();
        return;
      }

      if (!result?.success || !result.order) {
        return;
      }

      applyOrderUpdateToServices(this.model, result.orderNumber, result.order, service);
      this.applyFilterSelect();
    });
  }

  openDialogNumReservaManual(
    tipo: string,
    nombreServicio: string,
    idItinerary: string,
    idRegistro: string,
    nombreProveedor: string,
    editcode: boolean,
    service?: any
  ): void {
    const dialogRef = this.functions.openDialogNumReservaManual(
      tipo,
      nombreServicio,
      idItinerary,
      idRegistro,
      nombreProveedor,
      'transportes',
      editcode,
      service?.order?.orderId,
      service
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.shouldRefresh) {
        this.onSelectionChanged();
        return;
      }

      if (!result?.success || !result.order) {
        return;
      }

      applyOrderUpdateToServices(this.model, result.orderNumber, result.order, service);
      this.applyFilterSelect();
    });
  }

  openDialogEditFechaPagoProgramada(service: any): void {
    const dialogRef = this.functions.openDialogEditFechaPagoProgramada({ service });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.shouldRefresh) {
        this.onSelectionChanged();
        return;
      }

      if (!result?.success) {
        return;
      }

      const scheduledPaymentDate = result.order?.scheduledPaymentDate
        ?? (result.newDate ? new Date(result.newDate).toISOString() : null);

      applyOrderUpdateToServices(
        this.model,
        result.orderNumber ?? service.order?.orderNumber,
        result.order ?? { scheduledPaymentDate },
        service
      );
      this.applyFilterSelect();
    });
  }

  applyFilterSelect() {
    let dataNew: any = this.model;

    this.categoriaOfServiceSelected = this._normalizeFilterValue(
      this.categoriaControl.value
    )
      ? this.categoriaControl.value
      : null;
    this.selectService = this._normalizeFilterValue(this.servicioControl.value)
      ? this.servicioControl.value
      : null;
    this.selectEstadoOS = this._normalizeFilterValue(this.estadoOsControl.value)
      ? this.estadoOsControl.value
      : null;
    this.selectOrderNumber = this._normalizeFilterValue(this.numOsControl.value)
      ? this.numOsControl.value
      : null;
    this.selectProveedor = this._normalizeFilterValue(
      this.proveedorControl.value
    )
      ? this.proveedorControl.value
      : null;

    if (this.selectNumberFile) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileNumber == this.selectNumberFile
      );
    }

    if (this.daySelected) {
      dataNew = dataNew?.filter((item: any) => item.day === this.daySelected);
    }

    if (this.categoriaOfServiceSelected) {
      dataNew = dataNew?.filter(
        (item: any) =>
          item.categoriaServicio === this.categoriaOfServiceSelected
      );
    }

    if (this.selectService) {
      dataNew = dataNew?.filter(
        (item: any) => item.nombreServicio === this.selectService
      );
    }

    if (this.selectDate) {
      dataNew = dataNew?.filter((item: any) => item.date === this.selectDate);
    }

    if (this.selectClient) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileName === this.selectClient
      );
    }

    if (this.selectOrderNumber) {
      dataNew = dataNew?.filter((item: any) =>
        sameOrderNumberValue(item.order?.orderNumber, this.selectOrderNumber)
      );
    }

    if (this.selectProveedor) {
      dataNew = dataNew?.filter(
        (item: any) => item.providerSnapshot?.nombre === this.selectProveedor
      );
    }

    if (this.selectEstadoOS) {
      dataNew = dataNew?.filter(
        (item: any) => item.order?.orderStatus === this.selectEstadoOS
      );
    }

    if (this.startDateSelected && this.endDateSelected) {
      dataNew = dataNew?.filter(
        (item: any) =>
          new Date(this.startDateSelected) <=
            moment(item.dateToShow, 'DD.MM.YYYY').toDate() &&
          moment(item.dateToShow, 'DD.MM.YYYY').toDate() <=
            new Date(this.endDateSelected)
      );
    }

    this.personalCampoDataSource.data = Array.isArray(dataNew)
      ? [...dataNew]
      : [];
    this.applyFilter();
  }

  async sendReservaOS(): Promise<any> {
    if (this.orderService.isCreateOrderBusy) {
      return;
    }

    const serviceIds = [
      ...new Set(
        this.personalCampoDataSource.data
          .filter((fila: any) => fila.checked && this.isRowSelectable(fila))
          .map((s: any) => s.id)
          .filter(Boolean)
      )
    ] as string[];
    if (!serviceIds.length) return;

    const operationDates = this.personalCampoDataSource.data
      .filter((fila: any) => fila.checked && this.isRowSelectable(fila))
      .map((s: any) => s.startDateService ?? s.dateToShow ?? null);

    const dialogRef = this.dialog.open(
      CreateOrderComponent,
      buildCreateOrderDialogConfig({
        serviceIds,
        operationDates,
        contextLabel: 'Programación'
      })
    );

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) {
        return;
      }

      if (result.shouldRefresh) {
        this.deseleccionar();
        this.onSelectionChanged();
        return;
      }

      if (!result.success) {
        return;
      }

      this.deseleccionar();

      applyCreatedOrdersToServices(
        this.model ?? [],
        result.result?.createdOrders,
        'id',
        result.submittedInput
      );
      this.applyFilterSelect();
    });
  }

  deseleccionar() {
    this.personalCampoDataSource.data.forEach((row: any) => {
      row.checked = false;
    });
    this.estadoBtnMasivo = 0;
  }

  onApplyRangeSelected() {
    this.startDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.startDate))
    );
    this.endDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.endDate))
    );
    this.applyFilterSelect();
  }

  getDateTransform(date: string) {
    const dateSeparated = date.slice(1, 11).split('-');
    const month = dateSeparated[1];
    const day = dateSeparated[2];
    const year = dateSeparated[0];
    return month + '/' + day + '/' + year;
  }

  cleanDateSelected() {
    this.startDate = null;
    this.startDateSelected = null;
    this.endDate = null;
    this.endDateSelected = null;

    this.applyFilterSelect();
  }

  onSelectionChanged(options?: { silent?: boolean }) {
    this.categoriaOfServiceSelected = null;
    this.selectService = null;
    this.selectEstadoOS = null;
    this.selectOrderNumber = null;
    this.selectProveedor = null;

    this.categoriaControl.setValue('', { emitEvent: false });
    this.servicioControl.setValue('', { emitEvent: false });
    this.estadoOsControl.setValue('', { emitEvent: false });
    this.numOsControl.setValue('', { emitEvent: false });
    this.proveedorControl.setValue('', { emitEvent: false });

    if (!options?.silent) {
      this.loader = true;
    }
    this.showServices = true;

    const file = this.fileControl.value;
    this.isSSFF = Boolean(file?.isSSFFPadre);
    this.fileService
      .getProgrammingServicesAndOrdersByFile(file.id)
      .subscribe((res) => {
        this.applyProgrammingServices(
          res?.getProgrammingServicesAndOrdersByFile ?? [],
          file
        );
      });
  }

  private matchesAventuraLocation(service: any): boolean {
    const locacion = getProgrammingLocacion(service)?.toLowerCase();

    if (!locacion) {
      return true;
    }

    const routeLocation = this.location?.toLowerCase();
    if (!routeLocation) {
      return true;
    }

    return locacion === routeLocation;
  }

  private applyProgrammingServices(services: any[], file: any): void {
    const personalCampoServices = services.filter(
      (service: any) => service.tipoServicio === 'PERSONALDECAMPO'
    );

    const filteredByLocation = personalCampoServices.filter((service) =>
      this.matchesAventuraLocation(service)
    );

    const enriched = enrichServicesWithFileMeta(filteredByLocation, {
      fileNumber: file?.fileNumber,
      fileName: file?.fileName,
      fileExtend: file?.fileExtend,
      dateRange: file?.dateRange
    }).map((item: any) => {
      const dateRange = item.dateRange ?? file?.dateRange ?? null;
      const serviceDate =
        computeMassOsServiceDate(dateRange, item.day) ??
        (dateRange && item.day != null
          ? showServiceDate(dateRange, String(item.day))
          : null);

      return {
        ...item,
        serviceDate,
        dateToShow: serviceDate
          ? moment(serviceDate).format('DD.MM.YYYY')
          : item.dateToShow,
        nombreProveedor: item.providerSnapshot?.nombre ?? null
      };
    });

    const isSsffParent = Boolean(file?.isSSFFPadre);
    this.isSSFF = isSsffParent;

    const visibleServices = isSsffParent
      ? enriched
      : enriched.filter((item: any) => !(item.ssffproduct && item.productId));

    this.model = visibleServices.sort((a: any, b: any) => {
      return (
        a.day - b.day ||
        a.nombreServicio.localeCompare(b.nombreServicio) ||
        a.tipoServicio.localeCompare(b.tipoServicio) ||
        (a.categoriaServicio ?? '').localeCompare(b.categoriaServicio ?? '') ||
        (a.nombreProveedor ?? '').localeCompare(b.nombreProveedor ?? '')
      );
    });

    this.arrayDays = [...new Set(this.model.map((item: any) => item.day))];
    this.arrayServices = [
      ...new Set(this.model.map((item: any) => item.nombreServicio))
    ]
      .filter(Boolean)
      .sort((a: any, b: any) => a.localeCompare(b));
    this.categoriasFiltradas = [
      ...new Set(this.model.map((item: any) => item.categoriaServicio))
    ]
      .filter(Boolean)
      .sort((a: any, b: any) => a.localeCompare(b));
    this.arrayDates = [...new Set(this.model.map((item: any) => item.date))];
    this.arrayOrderNumbers = [
      ...new Set(this.model.map((item: any) => item.order?.orderNumber))
    ]
      .filter(Boolean)
      .sort((a: any, b: any) => a.localeCompare(b));
    this.arrayClients = [
      ...new Set(this.model.map((item: any) => item.fileName))
    ];
    this.arrayProveedores = [
      ...new Set(this.model.map((item: any) => item.providerSnapshot?.nombre))
    ]
      .filter(Boolean)
      .sort((a: any, b: any) => a.localeCompare(b));

    this.personalCampoDataSource.data = this.model;
    this.setupAutocompleteFilters();
    this.loader = false;
  }

  serviceDate(row: any): Date | null {
    if (row.serviceDate instanceof Date) {
      return row.serviceDate;
    }
    if (!row.dateRange || row.day == null) {
      return null;
    }
    return showServiceDate(row.dateRange, String(row.day));
  }
}
